var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client as apiClient } from './client';
export function getNodeStatuses() {
    return __awaiter(this, void 0, void 0, function* () {
        return apiClient.get('/node-statuses');
    });
}
export function createNodeStatus(data) {
    return __awaiter(this, void 0, void 0, function* () {
        return apiClient.post('/node-statuses', data);
    });
}
export function updateNodeStatus(id, data) {
    return __awaiter(this, void 0, void 0, function* () {
        return apiClient.patch(`/node-statuses/${id}`, data);
    });
}
export function deleteNodeStatus(id) {
    return __awaiter(this, void 0, void 0, function* () {
        yield apiClient.delete(`/node-statuses/${id}`);
    });
}
export function restoreNodeStatus(id) {
    return __awaiter(this, void 0, void 0, function* () {
        yield apiClient.patch(`/node-statuses/${id}/restore`);
    });
}
export function deleteNodeStatusPermanently(id) {
    return __awaiter(this, void 0, void 0, function* () {
        yield apiClient.delete(`/node-statuses/${id}/permanent`);
    });
}
